// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  min-height: 100vh;
  width: 100%;
  padding-top: 8rem;
  padding-bottom: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-bottom: 8rem;
}

.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 60%;
  margin: 0 auto;
  padding-bottom: 8rem;
}

.about-heading {
  color: white;
  font-size: 6rem;
  text-transform: uppercase;
  letter-spacing: 0.3rem;
  margin-bottom: 8rem;
}

.about-text {
  text-transform: uppercase;
  color: white;
  text-align: justify;
  margin-bottom: 1rem;
  font-size: 3rem;
  width: 100%;
}

.about-image {
  border: 6px solid black;
  border-radius: 20px;
  margin-top: 2rem;
  width: 100%;
  /* Set the width of the image to 100% */
  max-width: 100%;
  /* Set the maximum width of the image to 100% */
}

@media (min-width: 1400px) {

  .content-container {
    max-width: 70%;
    /* Reduce the width of the content container */
    flex-direction: row;
    /* Display the text and image side-by-side */
    justify-content: space-between;
    /* Add spacing between text and image */
  }


  .text-container {
    padding-left: 10rem;
  }

  /* Modified code for the second row */
  .content-container:nth-child(3) {
    flex-direction: row-reverse;
  }

  .text-container {
    width: 60%;
    /* Set the width of the text container */
    padding-right: 8rem;
  }

  .about-image {
    width: 40%;
    /* Set the width of the image container */
    max-width: none;
    /* Remove the maximum width restriction */
  }

}`, "",{"version":3,"sources":["webpack://./src/components/About.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,uCAAuC;EACvC,eAAe;EACf,+CAA+C;AACjD;;AAEA;;EAEE;IACE,cAAc;IACd,8CAA8C;IAC9C,mBAAmB;IACnB,4CAA4C;IAC5C,8BAA8B;IAC9B,uCAAuC;EACzC;;;EAGA;IACE,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;IACE,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wCAAwC;IACxC,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,yCAAyC;IACzC,eAAe;IACf,yCAAyC;EAC3C;;AAEF","sourcesContent":[".about {\n  min-height: 100vh;\n  width: 100%;\n  padding-top: 8rem;\n  padding-bottom: 4rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding-bottom: 8rem;\n}\n\n.content-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 60%;\n  margin: 0 auto;\n  padding-bottom: 8rem;\n}\n\n.about-heading {\n  color: white;\n  font-size: 6rem;\n  text-transform: uppercase;\n  letter-spacing: 0.3rem;\n  margin-bottom: 8rem;\n}\n\n.about-text {\n  text-transform: uppercase;\n  color: white;\n  text-align: justify;\n  margin-bottom: 1rem;\n  font-size: 3rem;\n  width: 100%;\n}\n\n.about-image {\n  border: 6px solid black;\n  border-radius: 20px;\n  margin-top: 2rem;\n  width: 100%;\n  /* Set the width of the image to 100% */\n  max-width: 100%;\n  /* Set the maximum width of the image to 100% */\n}\n\n@media (min-width: 1400px) {\n\n  .content-container {\n    max-width: 70%;\n    /* Reduce the width of the content container */\n    flex-direction: row;\n    /* Display the text and image side-by-side */\n    justify-content: space-between;\n    /* Add spacing between text and image */\n  }\n\n\n  .text-container {\n    padding-left: 10rem;\n  }\n\n  /* Modified code for the second row */\n  .content-container:nth-child(3) {\n    flex-direction: row-reverse;\n  }\n\n  .text-container {\n    width: 60%;\n    /* Set the width of the text container */\n    padding-right: 8rem;\n  }\n\n  .about-image {\n    width: 40%;\n    /* Set the width of the image container */\n    max-width: none;\n    /* Remove the maximum width restriction */\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
